// @flow

const EvolvedEducationBusinessId = 'deaebea9-42a2-4e31-b148-a446ea79a184';

// eslint-disable-next-line import/prefer-default-export
export const isSessionReportRatingEnabled = (businessId: string): boolean =>
  businessId !== EvolvedEducationBusinessId;



// WEBPACK FOOTER //
// ./src/utils/helpers/sessions/business-settings.js